import { getDisplayDomain } from '@/utils/urlDisplay.ts';

export { getDisplayDomain, normalizeUrl } from '@/utils/urlDisplay.ts';

export const isDatasetId = (value: string) => value.length === 16 || value.length === 19;

export const titleForItem = (id: string) => {
  if (isDatasetId(id)) return `Dataset ${id.slice(0, 6)}…`;
  return getDisplayDomain(id) ?? id;
};

export const addTabset = (items: string[]) => {
  return {
    type: 'tabset',
    weight: 100,
    children: items.map((item) => itemToTab(item)),
    active: true,
  };
};

export const initialJson = (items: string[]) => ({
  global: {
    enableEdgeDock: false,
    splitterSize: 6,
    tabEnableRename: false,
    tabEnableRenderOnDemand: false,
    tabSetEnableMaximize: false,
    tabSetEnableTabScrollbar: true,
  },
  borders: [],
  layout: {
    type: 'row',
    weight: 100,
    children: [addTabset(items)],
  },
});

export const itemToTab = (item: string) => {
  return {
    type: 'tab',
    id: `tab-${item}`,
    name: titleForItem(item),
    component: isDatasetId(item) ? 'dataset' : 'url',
    // stash the raw query-param item; we’ll sync back to the URL from this
    config: isDatasetId(item) ? { item } : { item },
  };
};
